<template>
  <div class="app-container query-batch">
    <div class="title">
      <h4>批次查询</h4>
    </div>
    <div class="content">
      <div class="head">
        <div class="head-title">
          查询省份：
        </div>
        <div class="head-main">
          {{ provinceObj.ProvinceName }}
        </div>
      </div>
      <div class="main" v-if="BatchListData.length !== 0">
        <div class="tablelist">
          <div class="tlist" v-for="(item,index) in BatchListData" :key="index">
            <div class="header">
              <div class="item">{{item.Year}}</div>
              <div class="item" v-if="item.SubjectTypeList&&item.SubjectTypeList.length>0">
                <span v-if="item.SubjectTypeList.includes(1)">物理</span>
                <span v-if="item.SubjectTypeList.includes(3)">理科</span>
              </div>
              <div class="item" v-if="item.SubjectTypeList&&item.SubjectTypeList.length>0">
                <span v-if="item.SubjectTypeList.includes(2)">历史</span>
                <span v-if="item.SubjectTypeList.includes(4)">文科</span>
              </div>
              <div class="item2" v-if="!item.SubjectTypeList||item.SubjectTypeList.length==0">
                  <span>分数</span>
              </div>
              <div class="clear"></div>
            </div>
            <div class="clear"></div>
            <div class="blist" v-for="(it,ind) in item.BatchList" :key="ind">
              <div class="bt">{{it.BatchName}}</div>
              <div class="bt" v-if="it.ScoreDic&&!it.ScoreDic.hasOwnProperty('0')">
                <span v-if="it.ScoreDic.hasOwnProperty('1')">{{it.ScoreDic[1]}}</span>
                <span v-if="it.ScoreDic.hasOwnProperty('3')">{{it.ScoreDic[3]}}</span>
              </div>
              <div class="bt" v-if="it.ScoreDic&&!it.ScoreDic.hasOwnProperty('0')">
                <span v-if="it.ScoreDic.hasOwnProperty('2')">{{it.ScoreDic[2]}}</span>
                <span v-if="it.ScoreDic.hasOwnProperty('4')">{{it.ScoreDic[4]}}</span>
              </div>
              <div class="bt2" v-if="it.ScoreDic&&it.ScoreDic.hasOwnProperty('0')">
                <span v-if="it.ScoreDic.hasOwnProperty('0')">{{it.ScoreDic[0]}}</span>
              </div>
              <div class="clear"></div>
            </div>
            <div class="clear"></div>
          </div>
        </div>
      </div>
      <div class="main-spare" v-else>暂无数据...</div>
    </div>
  </div>
</template>

<script>
  import API from '@/api/config'
  import { getStore } from '@/utils/utils';
  import {areaData} from '@/utils/data';
  export default {
    name: "query-batch",
    data() {
      return {
        BatchValue: '',
        BatchListData: [],
        provinceObj: {}
      }
    },
    mounted() {
      this.init()
    },
    methods: {
      init() {
        let temp = getStore('OrgProvince')
        if (temp) {
          this.provinceObj = JSON.parse(temp)
        }
        this.BatchValue = this.provinceObj.ProvinceId
        this.getBatchListData()
      },
      getBatchListData(){
        API.Query.GetAdmissionBatchList({ ProvinceId: this.BatchValue }).then(res => {
          this.BatchListData = res.Data
        })
      }
    }
  }
</script>
<style scoped lang="less">
.tablelist{
  width: 100%;
  border: 1px solid #ddd;
  border-radius: 5px;
  overflow: hidden;
  .tlist{
    width: 100%;
    .header{
      background-color: rgba(var(--themecolor),0.75);
      color: #fff;
      font-size: 14px;
      line-height: 40px;
      height: 40px;
      .item{
        width: calc(100% / 3);
        border-left: 1px solid #fff;
        height: 40px;
        text-indent: 20px;
        float: left;
      }
      .item:first-child{
        border-left: none;
        width: calc((100% / 3) - 2px);
      }
      .item2{
        width: calc(100% - (100% / 3));
        border-left: 1px solid #fff;
        height: 40px;
        text-indent: 20px;
        float: left;
      }
    }
    .blist{
      color: #555;
      font-size: 14px;
      line-height: 40px;
      height: 40px;
      .bt{
        width: calc(100% / 3);
        float: left;
        border-left: 1px solid #ddd;
        height: 40px;
        text-indent: 20px;
        border-top: 1px solid #ddd;
      }
      .bt:first-child{
        border-left: none;
        width: calc((100% / 3) - 2px);
      }
      .bt2{
        width: calc(100% - (100% / 3));
        float: left;
        border-left: 1px solid #ddd;
        height: 40px;
        text-indent: 20px;
        border-top: 1px solid #ddd;
      }
    }
  }
}
  .query-batch {
    padding: 2rem 0;
    .title {
      h4 {
        text-align: center;
        color: rgb(var(--themecolor));
        font-size: 20px;
      }
    }
    .content {
      .head {
        display: flex;
        align-items: center;
        margin: 2rem 0;
      }
      .main-spare{
        text-align: center;
        font-size: 18px;
        color: rgb(var(--themecolor));
      }
    }
  }
</style>
<style lang="less">
.query-batch .el-range-editor.is-active, .query-batch .el-range-editor.is-active:hover, .query-batch .el-select .el-input.is-focus .el-input__inner{
  border-color: rgba(var(--themecolor),0.75);
}
.query-batch .el-select .el-input__inner:focus,.query-batch .el-input__inner:focus{
  border-color: rgba(var(--themecolor),0.75);
}
.el-select-dropdown__item.selected{
  color: rgba(var(--themecolor),0.75);
}
</style>